// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Core Colors */
  --primary: #6366f1;
  --primary-dark: #4f46e5;
  --secondary: #8b5cf6;
  --accent: #ec4899;

  /* Theme: Dark (Default) */
  --background: radial-gradient(circle at 50% 50%, #030409 0%, #070918 60%, #010206 100%);
  --text-main: #ffffff;
  --text-secondary: #f8fafc;
  --text-muted: #cbd5e1;
  --text-inverse: #000000;

  /* Gradients */
  --gradient-main: linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%);
  --gradient-glow: conic-gradient(from 180deg at 50% 50%, #6366f1 0deg, #a855f7 180deg, #ec4899 360deg);
  --gradient-hover: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%);
  --gradient-heading: linear-gradient(to right, #f8fafc, #94a3b8);

  /* Glassmorphism 2.0 (Global) */
  --glass-blur: blur(32px) saturate(210%);
  --glass-border: 1px solid rgba(255, 255, 255, 0.07);
  --glass-shadow: 0 24px 60px -10px rgba(0, 0, 0, 0.7);
  --glass-inner-glow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15), inset 0 -1px 0 0 rgba(0, 0, 0, 0.25);

  /* Dashboard Specific (Dark) */
  --dashboard-bg: #030409;
  --surface: rgba(10, 15, 30, 0.35);
  --surface-light: rgba(255, 255, 255, 0.02);
  --header-bg: rgba(6, 8, 20, 0.35);
  --sidebar-bg: rgba(8, 12, 28, 0.4);
  --card-bg: rgba(18, 22, 43, 0.45);
  --card-hover-bg: rgba(26, 32, 62, 0.55);
  --card-border: rgba(255, 255, 255, 0.06);
  --grid-line: rgba(255, 255, 255, 0.02);

  /* Inputs defaults for Dark Mode */
  --bg-input: rgba(10, 12, 24, 0.45);
  --bg-input-focus: rgba(15, 20, 38, 0.55);
  --border-glass: rgba(255, 255, 255, 0.08);
  --text-primary: #ffffff;

  /* Dimensions */
  --sidebar-width: 260px;
  --sidebar-collapsed-width: 80px;
}

html[data-theme="light"] {
  /* Theme: Light Glass (Frosted) */
  --background: radial-gradient(circle at 50% 50%, #f6f8fd 0%, #eceffd 60%, #e0e6fb 100%) !important;
  --surface: rgba(255, 255, 255, 0.45);
  --surface-light: rgba(255, 255, 255, 0.65);
  --text-main: #1e293b;
  --text-secondary: #475569;
  --text-muted: #64748b;
  --text-inverse: #ffffff;

  /* Gradients (Light Overrides) */
  --gradient-heading: linear-gradient(to right, #0f172a, #475569);
  --gradient-main: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #db2777 100%);

  --glass-border: 1px solid rgba(255, 255, 255, 0.45) !important;
  --glass-shadow: 0 16px 36px -8px rgba(0, 0, 0, 0.05) !important;
  --glass-inner-glow: inset 0 1px 0 0 rgba(255, 255, 255, 0.9) !important;

  /* Dashboard Specific (Light) */
  --dashboard-bg: transparent !important;
  --header-bg: rgba(255, 255, 255, 0.45) !important;
  --sidebar-bg: rgba(255, 255, 255, 0.4) !important;
  --card-bg: rgba(255, 255, 255, 0.55) !important;
  --card-hover-bg: rgba(255, 255, 255, 0.75) !important;
  --card-border: rgba(255, 255, 255, 0.3) !important;
  --grid-line: rgba(0, 0, 0, 0.04) !important;

  /* Inputs overrides for Light Mode */
  --bg-input: rgba(255, 255, 255, 0.6) !important;
  --bg-input-focus: rgba(255, 255, 255, 0.75) !important;
  --border-glass: rgba(255, 255, 255, 0.45) !important;
  --text-primary: #1e293b !important;
}

body {
  margin: 0;
  font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  background: var(--background);
  color: var(--text-main);
  transition: background 0.4s ease, color 0.4s ease;
  position: relative;
  min-height: 100vh;
}

/* Atmospheric Ambient Glows */
body::before,
body::after {
  content: '';
  position: fixed;
  width: 120vw;
  height: 120vh;
  z-index: -2;
  pointer-events: none;
  opacity: 0.65;
}

body::before {
  background:
    radial-gradient(circle at 10% 20%, rgba(99, 102, 241, 0.18) 0%, transparent 45%),
    radial-gradient(circle at 80% 30%, rgba(139, 92, 246, 0.16) 0%, transparent 50%),
    radial-gradient(circle at 40% 75%, rgba(6, 182, 212, 0.14) 0%, transparent 45%);
  animation: floatOrb1 25s infinite ease-in-out alternate;
}

body::after {
  background:
    radial-gradient(circle at 85% 75%, rgba(236, 72, 153, 0.14) 0%, transparent 40%),
    radial-gradient(circle at 25% 65%, rgba(59, 130, 246, 0.18) 0%, transparent 50%);
  animation: floatOrb2 30s infinite ease-in-out alternate;
}

@keyframes floatOrb1 {
  0% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(4vw, -4vh) scale(1.06);
  }

  100% {
    transform: translate(-2vw, 2vh) scale(0.96);
  }
}

@keyframes floatOrb2 {
  0% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(-3vw, 3vh) scale(1.08);
  }

  100% {
    transform: translate(3vw, -3vh) scale(0.94);
  }
}

html[data-theme="light"] body::before {
  background:
    radial-gradient(circle at 15% 20%, rgba(99, 102, 241, 0.08) 0%, transparent 45%),
    radial-gradient(circle at 85% 35%, rgba(139, 92, 246, 0.07) 0%, transparent 50%);
  animation: floatOrb1 25s infinite ease-in-out alternate;
}

html[data-theme="light"] body::after {
  background:
    radial-gradient(circle at 80% 80%, rgba(236, 72, 153, 0.06) 0%, transparent 40%);
  animation: floatOrb2 30s infinite ease-in-out alternate;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Force standard checkbox details */
input[type="checkbox"] {
  width: 14px !important;
  height: 14px !important;
  min-width: 14px !important;
  min-height: 14px !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

/* Glassmorphic Form Inputs Global overrides */
input[type="text"],
input[type="password"],
input[type="number"],
input[type="email"],
select,
textarea {
  background: var(--bg-input, rgba(10, 12, 24, 0.45)) !important;
  border: 1px solid var(--border-glass, rgba(255, 255, 255, 0.08)) !important;
  color: var(--text-primary) !important;
  border-radius: 12px !important;
  padding: 10px 14px !important;
  backdrop-filter: var(--glass-blur);
  font-family: 'Outfit', sans-serif !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

input[type="text"]:focus,
input[type="password"]:focus,
input[type="number"]:focus,
input[type="email"]:focus,
select:focus,
textarea:focus {
  outline: none !important;
  border-color: rgba(99, 102, 241, 0.5) !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2), 0 0 12px rgba(99, 102, 241, 0.25) !important;
  background: var(--bg-input-focus, rgba(15, 20, 38, 0.55)) !important;
}

/* AWS Logo Fix for Dark Mode globally */
.aws-logo-theme-fix {
  filter: invert(1) hue-rotate(180deg);
  transition: filter 0.3s ease;
}

html[data-theme="light"] .aws-logo-theme-fix {
  filter: none;
}


input[type="text"]:focus,
input[type="password"]:focus,
input[type="number"]:focus,
input[type="email"]:focus,
select:focus,
textarea:focus {
  outline: none !important;
  border-color: rgba(99, 102, 241, 0.5) !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2), 0 0 12px rgba(99, 102, 241, 0.25) !important;
  background: var(--bg-input-focus, rgba(15, 20, 38, 0.55)) !important;
}

/* AWS Logo Fix for Dark Mode globally */
.aws-logo-theme-fix {
  filter: invert(1) hue-rotate(180deg);
  transition: filter 0.3s ease;
}

html[data-theme="light"] .aws-logo-theme-fix {
  filter: none;
}

/* --- Caption Highlight --- */
.highlighted-caption {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  background: var(--gradient-main);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  background-size: 200% auto;
  animation: captionShine 4s linear infinite;
  display: inline-block;
}

@keyframes captionShine {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}

/* --- Header Ticker --- */
.header-ticker-container {
  display: flex;
  align-items: center;
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 30px;
  padding: 4px 14px;
  margin-left: 24px;
  height: 34px;
  max-width: 460px;
  width: 460px;
  overflow: hidden;
  position: relative;
  gap: 10px;
  backdrop-filter: blur(16px);
  animation: borderGlowPulse 4s ease-in-out infinite;
  transition: all 0.3s ease;
}

.header-ticker-container:hover {
  animation-play-state: paused;
  border-color: rgba(168, 85, 247, 0.65) !important;
  box-shadow: 0 0 20px rgba(168, 85, 247, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.15) !important;
  transform: translateY(-1px);
}

@keyframes borderGlowPulse {
  0% {
    border-color: rgba(99, 102, 241, 0.3);
    box-shadow: 0 0 8px rgba(99, 102, 241, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.05);
  }
  50% {
    border-color: rgba(168, 85, 247, 0.5);
    box-shadow: 0 0 16px rgba(168, 85, 247, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }
  100% {
    border-color: rgba(99, 102, 241, 0.3);
    box-shadow: 0 0 8px rgba(99, 102, 241, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.05);
  }
}

html[data-theme="light"] .header-ticker-container {
  background: rgba(99, 102, 241, 0.04);
  border-color: rgba(99, 102, 241, 0.25);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.05);
  animation: borderGlowPulseLight 4s ease-in-out infinite;
}

@keyframes borderGlowPulseLight {
  0% {
    border-color: rgba(99, 102, 241, 0.25);
    box-shadow: 0 0 6px rgba(99, 102, 241, 0.08);
  }
  50% {
    border-color: rgba(168, 85, 247, 0.35);
    box-shadow: 0 0 12px rgba(168, 85, 247, 0.15);
  }
  100% {
    border-color: rgba(99, 102, 241, 0.25);
    box-shadow: 0 0 6px rgba(99, 102, 241, 0.08);
  }
}

.ticker-badge {
  background: var(--gradient-main);
  color: #ffffff !important;
  font-size: 0.65rem;
  font-weight: 900;
  padding: 2px 9px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  flex-shrink: 0;
  box-shadow: 0 0 10px rgba(168, 85, 247, 0.45);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.ticker-pulse {
  width: 7px;
  height: 7px;
  background-color: #f59e0b;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 8px #f59e0b;
  animation: tickerPulse 2s infinite;
}

@keyframes tickerPulse {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 4px #f59e0b, 0 0 0 0 rgba(245, 158, 11, 0.6);
  }
  70% {
    transform: scale(1.1);
    box-shadow: 0 0 8px #f59e0b, 0 0 0 8px rgba(245, 158, 11, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 4px #f59e0b, 0 0 0 0 rgba(245, 158, 11, 0);
  }
}

.ticker-scroll {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  mask-image: linear-gradient(to right, transparent, white 15px, white 95%, transparent);
  -webkit-mask-image: linear-gradient(to right, transparent, white 15px, white 95%, transparent);
}

.ticker-item {
  position: absolute;
  width: max-content;
  white-space: nowrap;
  margin: 0;
  font-size: 0.725rem;
  font-weight: 600;
  color: var(--text-main);
  letter-spacing: 0.2px;
  animation: tickerScroll 24s linear infinite;
}

.ticker-scroll:hover .ticker-item {
  animation-play-state: paused;
  cursor: pointer;
}

@keyframes tickerScroll {
  0% {
    transform: translateX(380px);
  }
  100% {
    transform: translateX(-100%);
  }
}

@media (max-width: 1024px) {
  .header-ticker-container {
    display: none;
  }
}

/* --- Ticker Logo Inline Styles --- */
.ticker-logo-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 8px;
  vertical-align: middle;
  background: rgba(255, 255, 255, 0.05);
  padding: 3px 8px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

html[data-theme="light"] .ticker-logo-group {
  background: rgba(0, 0, 0, 0.03);
  border-color: rgba(0, 0, 0, 0.05);
}

.ticker-logo-group.muted {
  opacity: 0.6;
}

.ticker-logo {
  height: 14px;
  width: auto;
  object-fit: contain;
  vertical-align: middle;
}

.ticker-arrow {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--primary);
  margin: 0 2px;
}

.coming-soon-tag {
  font-size: 0.6rem;
  font-weight: 700;
  color: var(--accent);
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;;EAEjB,0BAA0B;EAC1B,uFAAuF;EACvF,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;;EAEvB,cAAc;EACd,+EAA+E;EAC/E,qGAAqG;EACrG,mGAAmG;EACnG,+DAA+D;;EAE/D,+BAA+B;EAC/B,uCAAuC;EACvC,mDAAmD;EACnD,oDAAoD;EACpD,mGAAmG;;EAEnG,8BAA8B;EAC9B,uBAAuB;EACvB,iCAAiC;EACjC,0CAA0C;EAC1C,iCAAiC;EACjC,kCAAkC;EAClC,iCAAiC;EACjC,uCAAuC;EACvC,wCAAwC;EACxC,sCAAsC;;EAEtC,kCAAkC;EAClC,kCAAkC;EAClC,wCAAwC;EACxC,yCAAyC;EACzC,uBAAuB;;EAEvB,eAAe;EACf,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,kGAAkG;EAClG,oCAAoC;EACpC,0CAA0C;EAC1C,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;;EAEvB,gCAAgC;EAChC,+DAA+D;EAC/D,+EAA+E;;EAE/E,8DAA8D;EAC9D,+DAA+D;EAC/D,uEAAuE;;EAEvE,+BAA+B;EAC/B,sCAAsC;EACtC,iDAAiD;EACjD,iDAAiD;EACjD,+CAA+C;EAC/C,qDAAqD;EACrD,kDAAkD;EAClD,2CAA2C;;EAE3C,oCAAoC;EACpC,+CAA+C;EAC/C,sDAAsD;EACtD,oDAAoD;EACpD,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,+GAA+G;EAC/G,mCAAmC;EACnC,6BAA6B;EAC7B,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE;;;mFAGiF;EACjF,uDAAuD;AACzD;;AAEA;EACE;;oFAEkF;EAClF,uDAAuD;AACzD;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;;oFAEkF;EAClF,uDAAuD;AACzD;;AAEA;EACE;oFACkF;EAClF,uDAAuD;AACzD;;AAEA;EACE;aACW;AACb;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA,8CAA8C;AAC9C;;;;;;EAME,8DAA8D;EAC9D,2EAA2E;EAC3E,qCAAqC;EACrC,8BAA8B;EAC9B,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;EAC5C,8CAA8C;EAC9C,8DAA8D;AAChE;;AAEA;;;;;;EAME,wBAAwB;EACxB,gDAAgD;EAChD,4FAA4F;EAC5F,oEAAoE;AACtE;;AAEA,wCAAwC;AACxC;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;;AAGA;;;;;;EAME,wBAAwB;EACxB,gDAAgD;EAChD,4FAA4F;EAC5F,oEAAoE;AACtE;;AAEA,wCAAwC;AACxC;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,KAAK,8BAA8B,EAAE;EACrC,OAAO,gCAAgC,EAAE;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,iDAAiD;EACjD,iGAAiG;EACjG,2BAA2B;AAC7B;;AAEA;EACE;IACE,qCAAqC;IACrC,qFAAqF;EACvF;EACA;IACE,qCAAqC;IACrC,oFAAoF;EACtF;EACA;IACE,qCAAqC;IACrC,qFAAqF;EACvF;AACF;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA;EACE;IACE,sCAAsC;IACtC,4CAA4C;EAC9C;EACA;IACE,sCAAsC;IACtC,6CAA6C;EAC/C;EACA;IACE,sCAAsC;IACtC,4CAA4C;EAC9C;AACF;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,6CAA6C;EAC7C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE;IACE,qBAAqB;IACrB,4DAA4D;EAC9D;EACA;IACE,qBAAqB;IACrB,4DAA4D;EAC9D;EACA;IACE,qBAAqB;IACrB,0DAA0D;EAC5D;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sFAAsF;EACtF,8FAA8F;AAChG;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');\n\n:root {\n  /* Core Colors */\n  --primary: #6366f1;\n  --primary-dark: #4f46e5;\n  --secondary: #8b5cf6;\n  --accent: #ec4899;\n\n  /* Theme: Dark (Default) */\n  --background: radial-gradient(circle at 50% 50%, #030409 0%, #070918 60%, #010206 100%);\n  --text-main: #ffffff;\n  --text-secondary: #f8fafc;\n  --text-muted: #cbd5e1;\n  --text-inverse: #000000;\n\n  /* Gradients */\n  --gradient-main: linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%);\n  --gradient-glow: conic-gradient(from 180deg at 50% 50%, #6366f1 0deg, #a855f7 180deg, #ec4899 360deg);\n  --gradient-hover: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%);\n  --gradient-heading: linear-gradient(to right, #f8fafc, #94a3b8);\n\n  /* Glassmorphism 2.0 (Global) */\n  --glass-blur: blur(32px) saturate(210%);\n  --glass-border: 1px solid rgba(255, 255, 255, 0.07);\n  --glass-shadow: 0 24px 60px -10px rgba(0, 0, 0, 0.7);\n  --glass-inner-glow: inset 0 1px 0 0 rgba(255, 255, 255, 0.15), inset 0 -1px 0 0 rgba(0, 0, 0, 0.25);\n\n  /* Dashboard Specific (Dark) */\n  --dashboard-bg: #030409;\n  --surface: rgba(10, 15, 30, 0.35);\n  --surface-light: rgba(255, 255, 255, 0.02);\n  --header-bg: rgba(6, 8, 20, 0.35);\n  --sidebar-bg: rgba(8, 12, 28, 0.4);\n  --card-bg: rgba(18, 22, 43, 0.45);\n  --card-hover-bg: rgba(26, 32, 62, 0.55);\n  --card-border: rgba(255, 255, 255, 0.06);\n  --grid-line: rgba(255, 255, 255, 0.02);\n\n  /* Inputs defaults for Dark Mode */\n  --bg-input: rgba(10, 12, 24, 0.45);\n  --bg-input-focus: rgba(15, 20, 38, 0.55);\n  --border-glass: rgba(255, 255, 255, 0.08);\n  --text-primary: #ffffff;\n\n  /* Dimensions */\n  --sidebar-width: 260px;\n  --sidebar-collapsed-width: 80px;\n}\n\nhtml[data-theme=\"light\"] {\n  /* Theme: Light Glass (Frosted) */\n  --background: radial-gradient(circle at 50% 50%, #f6f8fd 0%, #eceffd 60%, #e0e6fb 100%) !important;\n  --surface: rgba(255, 255, 255, 0.45);\n  --surface-light: rgba(255, 255, 255, 0.65);\n  --text-main: #1e293b;\n  --text-secondary: #475569;\n  --text-muted: #64748b;\n  --text-inverse: #ffffff;\n\n  /* Gradients (Light Overrides) */\n  --gradient-heading: linear-gradient(to right, #0f172a, #475569);\n  --gradient-main: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #db2777 100%);\n\n  --glass-border: 1px solid rgba(255, 255, 255, 0.45) !important;\n  --glass-shadow: 0 16px 36px -8px rgba(0, 0, 0, 0.05) !important;\n  --glass-inner-glow: inset 0 1px 0 0 rgba(255, 255, 255, 0.9) !important;\n\n  /* Dashboard Specific (Light) */\n  --dashboard-bg: transparent !important;\n  --header-bg: rgba(255, 255, 255, 0.45) !important;\n  --sidebar-bg: rgba(255, 255, 255, 0.4) !important;\n  --card-bg: rgba(255, 255, 255, 0.55) !important;\n  --card-hover-bg: rgba(255, 255, 255, 0.75) !important;\n  --card-border: rgba(255, 255, 255, 0.3) !important;\n  --grid-line: rgba(0, 0, 0, 0.04) !important;\n\n  /* Inputs overrides for Light Mode */\n  --bg-input: rgba(255, 255, 255, 0.6) !important;\n  --bg-input-focus: rgba(255, 255, 255, 0.75) !important;\n  --border-glass: rgba(255, 255, 255, 0.45) !important;\n  --text-primary: #1e293b !important;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  background: var(--background);\n  color: var(--text-main);\n  transition: background 0.4s ease, color 0.4s ease;\n  position: relative;\n  min-height: 100vh;\n}\n\n/* Atmospheric Ambient Glows */\nbody::before,\nbody::after {\n  content: '';\n  position: fixed;\n  width: 120vw;\n  height: 120vh;\n  z-index: -2;\n  pointer-events: none;\n  opacity: 0.65;\n}\n\nbody::before {\n  background:\n    radial-gradient(circle at 10% 20%, rgba(99, 102, 241, 0.18) 0%, transparent 45%),\n    radial-gradient(circle at 80% 30%, rgba(139, 92, 246, 0.16) 0%, transparent 50%),\n    radial-gradient(circle at 40% 75%, rgba(6, 182, 212, 0.14) 0%, transparent 45%);\n  animation: floatOrb1 25s infinite ease-in-out alternate;\n}\n\nbody::after {\n  background:\n    radial-gradient(circle at 85% 75%, rgba(236, 72, 153, 0.14) 0%, transparent 40%),\n    radial-gradient(circle at 25% 65%, rgba(59, 130, 246, 0.18) 0%, transparent 50%);\n  animation: floatOrb2 30s infinite ease-in-out alternate;\n}\n\n@keyframes floatOrb1 {\n  0% {\n    transform: translate(0, 0) scale(1);\n  }\n\n  50% {\n    transform: translate(4vw, -4vh) scale(1.06);\n  }\n\n  100% {\n    transform: translate(-2vw, 2vh) scale(0.96);\n  }\n}\n\n@keyframes floatOrb2 {\n  0% {\n    transform: translate(0, 0) scale(1);\n  }\n\n  50% {\n    transform: translate(-3vw, 3vh) scale(1.08);\n  }\n\n  100% {\n    transform: translate(3vw, -3vh) scale(0.94);\n  }\n}\n\nhtml[data-theme=\"light\"] body::before {\n  background:\n    radial-gradient(circle at 15% 20%, rgba(99, 102, 241, 0.08) 0%, transparent 45%),\n    radial-gradient(circle at 85% 35%, rgba(139, 92, 246, 0.07) 0%, transparent 50%);\n  animation: floatOrb1 25s infinite ease-in-out alternate;\n}\n\nhtml[data-theme=\"light\"] body::after {\n  background:\n    radial-gradient(circle at 80% 80%, rgba(236, 72, 153, 0.06) 0%, transparent 40%);\n  animation: floatOrb2 30s infinite ease-in-out alternate;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Force standard checkbox details */\ninput[type=\"checkbox\"] {\n  width: 14px !important;\n  height: 14px !important;\n  min-width: 14px !important;\n  min-height: 14px !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n}\n\n/* Glassmorphic Form Inputs Global overrides */\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ninput[type=\"email\"],\nselect,\ntextarea {\n  background: var(--bg-input, rgba(10, 12, 24, 0.45)) !important;\n  border: 1px solid var(--border-glass, rgba(255, 255, 255, 0.08)) !important;\n  color: var(--text-primary) !important;\n  border-radius: 12px !important;\n  padding: 10px 14px !important;\n  backdrop-filter: var(--glass-blur);\n  font-family: 'Outfit', sans-serif !important;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1) !important;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"number\"]:focus,\ninput[type=\"email\"]:focus,\nselect:focus,\ntextarea:focus {\n  outline: none !important;\n  border-color: rgba(99, 102, 241, 0.5) !important;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2), 0 0 12px rgba(99, 102, 241, 0.25) !important;\n  background: var(--bg-input-focus, rgba(15, 20, 38, 0.55)) !important;\n}\n\n/* AWS Logo Fix for Dark Mode globally */\n.aws-logo-theme-fix {\n  filter: invert(1) hue-rotate(180deg);\n  transition: filter 0.3s ease;\n}\n\nhtml[data-theme=\"light\"] .aws-logo-theme-fix {\n  filter: none;\n}\n\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"number\"]:focus,\ninput[type=\"email\"]:focus,\nselect:focus,\ntextarea:focus {\n  outline: none !important;\n  border-color: rgba(99, 102, 241, 0.5) !important;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2), 0 0 12px rgba(99, 102, 241, 0.25) !important;\n  background: var(--bg-input-focus, rgba(15, 20, 38, 0.55)) !important;\n}\n\n/* AWS Logo Fix for Dark Mode globally */\n.aws-logo-theme-fix {\n  filter: invert(1) hue-rotate(180deg);\n  transition: filter 0.3s ease;\n}\n\nhtml[data-theme=\"light\"] .aws-logo-theme-fix {\n  filter: none;\n}\n\n/* --- Caption Highlight --- */\n.highlighted-caption {\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  background: var(--gradient-main);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: transparent;\n  background-size: 200% auto;\n  animation: captionShine 4s linear infinite;\n  display: inline-block;\n}\n\n@keyframes captionShine {\n  0% { background-position: 0% center; }\n  100% { background-position: 200% center; }\n}\n\n/* --- Header Ticker --- */\n.header-ticker-container {\n  display: flex;\n  align-items: center;\n  background: rgba(99, 102, 241, 0.08);\n  border: 1px solid rgba(99, 102, 241, 0.3);\n  border-radius: 30px;\n  padding: 4px 14px;\n  margin-left: 24px;\n  height: 34px;\n  max-width: 460px;\n  width: 460px;\n  overflow: hidden;\n  position: relative;\n  gap: 10px;\n  backdrop-filter: blur(16px);\n  animation: borderGlowPulse 4s ease-in-out infinite;\n  transition: all 0.3s ease;\n}\n\n.header-ticker-container:hover {\n  animation-play-state: paused;\n  border-color: rgba(168, 85, 247, 0.65) !important;\n  box-shadow: 0 0 20px rgba(168, 85, 247, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.15) !important;\n  transform: translateY(-1px);\n}\n\n@keyframes borderGlowPulse {\n  0% {\n    border-color: rgba(99, 102, 241, 0.3);\n    box-shadow: 0 0 8px rgba(99, 102, 241, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n  }\n  50% {\n    border-color: rgba(168, 85, 247, 0.5);\n    box-shadow: 0 0 16px rgba(168, 85, 247, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  }\n  100% {\n    border-color: rgba(99, 102, 241, 0.3);\n    box-shadow: 0 0 8px rgba(99, 102, 241, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n  }\n}\n\nhtml[data-theme=\"light\"] .header-ticker-container {\n  background: rgba(99, 102, 241, 0.04);\n  border-color: rgba(99, 102, 241, 0.25);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.05);\n  animation: borderGlowPulseLight 4s ease-in-out infinite;\n}\n\n@keyframes borderGlowPulseLight {\n  0% {\n    border-color: rgba(99, 102, 241, 0.25);\n    box-shadow: 0 0 6px rgba(99, 102, 241, 0.08);\n  }\n  50% {\n    border-color: rgba(168, 85, 247, 0.35);\n    box-shadow: 0 0 12px rgba(168, 85, 247, 0.15);\n  }\n  100% {\n    border-color: rgba(99, 102, 241, 0.25);\n    box-shadow: 0 0 6px rgba(99, 102, 241, 0.08);\n  }\n}\n\n.ticker-badge {\n  background: var(--gradient-main);\n  color: #ffffff !important;\n  font-size: 0.65rem;\n  font-weight: 900;\n  padding: 2px 9px;\n  border-radius: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  flex-shrink: 0;\n  box-shadow: 0 0 10px rgba(168, 85, 247, 0.45);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.ticker-pulse {\n  width: 7px;\n  height: 7px;\n  background-color: #f59e0b;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: 0 0 8px #f59e0b;\n  animation: tickerPulse 2s infinite;\n}\n\n@keyframes tickerPulse {\n  0% {\n    transform: scale(0.9);\n    box-shadow: 0 0 4px #f59e0b, 0 0 0 0 rgba(245, 158, 11, 0.6);\n  }\n  70% {\n    transform: scale(1.1);\n    box-shadow: 0 0 8px #f59e0b, 0 0 0 8px rgba(245, 158, 11, 0);\n  }\n  100% {\n    transform: scale(0.9);\n    box-shadow: 0 0 4px #f59e0b, 0 0 0 0 rgba(245, 158, 11, 0);\n  }\n}\n\n.ticker-scroll {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  mask-image: linear-gradient(to right, transparent, white 15px, white 95%, transparent);\n  -webkit-mask-image: linear-gradient(to right, transparent, white 15px, white 95%, transparent);\n}\n\n.ticker-item {\n  position: absolute;\n  width: max-content;\n  white-space: nowrap;\n  margin: 0;\n  font-size: 0.725rem;\n  font-weight: 600;\n  color: var(--text-main);\n  letter-spacing: 0.2px;\n  animation: tickerScroll 24s linear infinite;\n}\n\n.ticker-scroll:hover .ticker-item {\n  animation-play-state: paused;\n  cursor: pointer;\n}\n\n@keyframes tickerScroll {\n  0% {\n    transform: translateX(380px);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n@media (max-width: 1024px) {\n  .header-ticker-container {\n    display: none;\n  }\n}\n\n/* --- Ticker Logo Inline Styles --- */\n.ticker-logo-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 8px;\n  vertical-align: middle;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 3px 8px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\nhtml[data-theme=\"light\"] .ticker-logo-group {\n  background: rgba(0, 0, 0, 0.03);\n  border-color: rgba(0, 0, 0, 0.05);\n}\n\n.ticker-logo-group.muted {\n  opacity: 0.6;\n}\n\n.ticker-logo {\n  height: 14px;\n  width: auto;\n  object-fit: contain;\n  vertical-align: middle;\n}\n\n.ticker-arrow {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--primary);\n  margin: 0 2px;\n}\n\n.coming-soon-tag {\n  font-size: 0.6rem;\n  font-weight: 700;\n  color: var(--accent);\n  margin-left: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
